import { useState } from 'react'
import { useNavigate, useLocation } from 'react-router'
import { useTranslation } from 'react-i18next'
import Header from '@components/Header/Header'
import AccountNumberInput from '@components/AccountNumberInput/AccountNumberInput'
import NumericKeyboard from '@components/NumericKeyboard/NumericKeyboard'
import PrimaryButton from '@components/PrimaryButton/PrimaryButton'
import {
  Container,
  ContentContainer,
  KeyboardButtonWrapper
} from './InternetCableTVDetail.styles'

const InternetCableTVDetail = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useTranslation()
  const provider = location.state?.provider

  const [accountNumber, setAccountNumber] = useState('')

  const handleKeyboardChange = (value: string | 'delete') => {
    if (value === 'delete') {
      setAccountNumber(prev => prev.slice(0, -1))
    } else {
      setAccountNumber(prev => prev + value)
    }
  }

  const handleAccountNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAccountNumber(e.target.value)
  }

  const handleContinue = () => {
    navigate('/payment-confirm', {
      state: {
        accountNumber,
        provider: provider?.name,
        serviceType: 'internet-cable-tv'
      }
    })
  }

  const isContinueDisabled = accountNumber.length === 0

  return (
    <Container>
      <Header
        title={provider?.name?.toUpperCase() || t('internetCableTV.header')}
        showBackButton={true}
        onBackClick={() => navigate(-1)}
      />
      <ContentContainer>
        <AccountNumberInput
          title={t('internetCableTVDetail.accountNumberLabel', { provider: provider?.name || 'Provider' })}
          value={accountNumber}
          onChange={handleAccountNumberChange}
          placeholder={t('internetCableTVDetail.accountNumberPlaceholder')}
          inputMode="none"
        />
      </ContentContainer>
      <KeyboardButtonWrapper>
        <NumericKeyboard onChange={handleKeyboardChange} />
        <PrimaryButton
          onClick={handleContinue}
          disabled={isContinueDisabled}
        >
          {t('common.continue')}
        </PrimaryButton>
      </KeyboardButtonWrapper>
    </Container>
  )
}

export default InternetCableTVDetail
